import { constructEnum } from '@/lib/enum';

const ReviewPopupStyle = constructEnum('ReviewPopupStyle', {
  SHOW: 10,
  SHORTS: 30
});

export default ReviewPopupStyle;
